export default __webpack_public_path__ + "static/media/78.8915e926.jpeg";